// [claude]
// Subtle Billing control beside the name on /subscribe/:token. Same click
// handler as the Pro/Founders badge (in-app Manage Subscription offcanvas).
// Shown only when TezLab has a Stripe subscription on file
// (can_adjust_vehicle_connections). Store-only Apple/Google Play members
// do not see it. When Billing is shown, the badge handler opens the drawer
// (the skip-to-portal branch is founders && !can_adjust, which hides Billing).
// Last updated: 2026-10-14

function membershipHeaderShowsBilling(connectAdjust) {
	return !!(connectAdjust && connectAdjust.can_adjust_vehicle_connections)
}

module.exports = { membershipHeaderShowsBilling }
